// LoaderComponent.js
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
function GlobalLoader() {
    return /*#__PURE__*/ _jsx("div", {
        className: "global-loader-overlay",
        children: /*#__PURE__*/ _jsx("div", {
            className: "spinner-border text-dark",
            role: "status"
        })
    });
}
export default GlobalLoader;
